export default "__VITE_ASSET__D5TD4mYV__"